module.exports = __webpack_public_path__ + "static/media/icon10.0bb3b0e6.svg";